import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import NavBar from './components/FrontEnd/NavBar.component';
import Main from './components/FrontEnd/Main.components';
import Gallery from './components/FrontEnd/Gallery.component';
import About from './components/FrontEnd/About.component';

import NotFound from './components/FrontEnd/NotFound.component';

const App = () => {
  return (
    <Router>
      <div className='App' id='wrapper'>
        <NavBar />
        <Switch>
          <Route exact path='/' component={Main} />
          <Route exact path='/gallery' component={Gallery} />
          <Route exact path='/about' component={About} />
          <Route component={NotFound} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
